import { RiskProfileRule, RiskProfileRuleData } from '@/types/risk-profiles';
import { DEFAULT_RISK_COLORS } from '@/utils/risk-profiles';
import classNames from 'classnames';
import React from 'react';
import { Tooltip } from '@/views/components/tooltips/';

interface RuleLegendFieldProps {
  data: RiskProfileRuleData;
  rule: RiskProfileRule;
  className?: string;
  showTooltip?: boolean;
  showLegendColor?: boolean;
}

const RiskProfileRuleLegendField = ({ data, rule, className, showTooltip = false, showLegendColor = true }: RuleLegendFieldProps) => (
  <div className={classNames('risk-profile-rule-legend-field', className)}>
    {showLegendColor && <div className="profile-legend-color" style={{ backgroundColor: DEFAULT_RISK_COLORS[rule.ruleType][data.key] }} />}

    {showTooltip ? (
      <Tooltip className="profile-legend-tooltip" title={data.label}>
        <span className="profile-legend-label">{data.label}</span>
      </Tooltip>
    ) : (
      <span className="profile-legend-label">{data.label}</span>
    )}
  </div>
);

export default RiskProfileRuleLegendField;
